<template>
  <ChatAi />
</template>

<script>
import ChatAi from "../components/MainComp";

export default {
  name: "Home",

  components: {
    ChatAi,
  },
};
</script>
